/* eslint-disable max-len */
import { store } from '../main';
import i18nDictionary from '../i18n';
import PreferencesData from '../data/preferences';

function toCurrency(price) {
  try {
    const language = (store && store.getState().settings.language) || PreferencesData.language;

    if (price) {
      if (i18nDictionary[language]) {
        if (language === 'pt-br') return Number(price).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
        if (language === 'es-ch') return `$ ${Number(price).toLocaleString('es-ch', { style: 'currency', currency: 'CLP' }).replace('CLP', '').trim()}`;
      } else {
        return Number(price).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      }
    }
  } catch (e) {
    if (price) return Number(price).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  }
}
function toPercentage(percentage) {
  return `${Number(percentage).toLocaleString('pt-br')}%`;
}

export default {
  toCurrency,
  toPercentage,
};
